import { apiClient } from './client';
import { API_ROUTES } from './routes';

export const dashboardService = {
  async getJobs(page = 1, pageSize = 10) {
    const response = await apiClient.get(API_ROUTES.DASHBOARD.JOBS, {
      params: { page, page_size: pageSize }
    });
    return response?.data || null;
  },

  async getPendingJobs() {
    const response = await apiClient.get(API_ROUTES.DASHBOARD.PENDING);
    return response?.data || null;
  },

  async getStats() {
    const response = await apiClient.get(API_ROUTES.DASHBOARD.STATS);
    return response?.data || null;
  }
};
